var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "ds-input-wrap" },
    [
      _vm.icon
        ? _c("ds-icon", {
            staticClass: "ds-input-icon",
            attrs: {
              name: _vm.icon,
              size: 18,
              filled: false,
              color: "var(--text-muted)",
            },
          })
        : _vm._e(),
      _c("input", {
        staticClass: "ds-input",
        class: {
          "ds-input--icon": !!_vm.icon,
          "ds-input--invalid": _vm.invalid,
        },
        attrs: {
          type: _vm.type,
          min: _vm.min,
          max: _vm.max,
          step: _vm.step,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
        },
        domProps: { value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.$emit("change", $event)
          },
          focus: function ($event) {
            _vm.focus = true
          },
          blur: function ($event) {
            _vm.focus = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }